import { jsonToGraphQLQuery } from 'json-to-graphql-query';
import { Preferences } from '@capacitor/preferences';
import { Device } from '@capacitor/device';
import { Browser } from '@capacitor/browser';
import {
  initiateGPSconfig,
  getGPSinstance,
  getCurrentPosition,
  startGPStracking,
  getGPStrackingShipmentID,
  setGPStrackingShipmentID,
  sendGeoStartTripLocation,
  setGeofenceSequenceNo,
  getGeofenceSequenceNo,
  getLoadDetailsTrackedShipment,
  setLoadDetailsTrackedShipment
} from '../services/gps.service';
import {
  DB_GPS_ACTIVATED_SHIPMENT,
  AUTH_SESSION_NAME,
  Roles,
  MYLOAD_DOCUMENT_UPLOAD,
  ESOURCE_TYPE_CHECK,
  CONTENT_OR_CONFIG_TABLE_MAPPING,
  REDIRECTION_SCHNEIDER_CARRIER_URL,
  EsourceTMSList,
  EdivisionList,
  GET_MEMBERS_CONFIG,
} from './constants';
import { getGeoCoderLatLong } from '../services/google-maps.service';
import { isPlatform } from '@ionic/react';
import { LPEFeedback } from '../schemas/LPEFeedback/LPEFeedback.schema';
import { GeographicalService } from '../services/GeoService';
import _ from 'lodash';
import { IuploadDocumentTypeList } from './AllInterface';
import { IUserDetails } from '../schemas/user';
import { isEmptyObject } from '../web/utils/BasicLogical.Util';
import { store } from 'app/store';
import DOMPurify from 'dompurify';

let getRole: string;
let userRole: any;
export interface Type<T> extends Function {
  new(...args: any[]): T;
}

export class DomainConverter {
  static dataToDomain<T>(domain: Type<T>, dto: any) {
    const instance = Object.create(domain.prototype);
    instance.__carrier_state = dto;
    return instance as T;
  }

  static domainToData<T>(domain: any) {
    const rqData: any = { query: `${jsonToGraphQLQuery(domain as T)}` };
    return JSON.stringify(rqData);
  }

  static dataToMutation<T>(domain: any, input: any) {
    const rqData: any = {
      query: `mutation ${jsonToGraphQLQuery(domain as T)}`,
      variables: { input }
    };
    return JSON.stringify(rqData);
  }
}

/**
 * To determine the entirleemnt of specified feature.
 * @param {string} _tab Application navigation tab name.
 * @param {string} _item feature of specified tab.
 * @returns {boolean} status of access on the specified feature.
 */
export function isEntitled(_tab: string, _item?: string) {
  return ((_tab, _item) => {
    const roleConfig = getRoleConfig();
    
    const tabScreen = 'screen';
    if (!IONICWrapper.details.keys || typeof userRole === "undefined") {
      return;
    }
    if (getUserGuestRoleCheck()) {
      if (_item) {
        return getTabScreeb(_item, tabScreen, _tab, roleConfig);
      } else {
        return true;
      }
    } else {
      let isActive = false;
      for (let i = 0; i <= userRole.length - 1; i++) {
        isActive = getIsActive(_item, tabScreen, _tab, i, roleConfig);
        if (isActive) {
          break;
        }
      }
      return isActive ? isActive : false;
    }
  })(_tab, _item);
}

function getIsActive(_item: string | undefined, tabScreen: string, _tab: string, i: number, roleConfig: any): boolean {
  return _item === tabScreen || !_item
    ? getActiveTab(_tab, userRole[i], roleConfig)
    : getConfig(_tab, _item, userRole[i], roleConfig);
}

function getUserGuestRoleCheck() {
  return userRole.length === 1 && userRole.includes(Roles.carrierGuest);
}

function getTabScreeb(_item: string, tabScreen: string, _tab: string, roleConfig: any) {
  return _item === tabScreen
    ? getActiveTab(_tab, userRole[0], roleConfig)
    : getConfig(_tab, _item, userRole[0], roleConfig);
}

function getRoleConfig() {
  return IONICWrapper.details?.keys &&
    IONICWrapper.details?.keys?.configuration?.roleConfigurations;
}

/**
 * To get the active tab when Application is initiated.
 * @param {string} tab Application navigation tab name.
 * @param {string} role role name.
 * @param {Object} Setting role configuration details.
 * @returns {boolean} status of access on the specified feature.
 */
function getActiveTab(tab: any, role: any, Setting: any) {
  return Object.keys(Setting)
    .filter((item: string) => item.includes(tab) && Setting[item])
    .map((item: any) => Setting[item][Object.keys(Setting[item])[0]][role])
    .some(item => item);
}

/**
 * To get the specific feature details as per the Role.
 * @param {string} _tab Application navigation tab name.
 * @param {string} _item feature name.
 * @param {string} _role role name.
 * @param {Object} _setting role configuration details.
 * @returns {boolean} status of access on the specified feature.
 */
function getConfig(_tab: string, _item: string, _role: any, _setting: any) {
  const __key =
    _tab + '.' + (_item && _item.charAt(0).toUpperCase() + _item.slice(1));
  return _setting[__key][_item][_role];
}

/**
 * To get the tab name to be landed when Application is launched.
* @param {string} role role name.
* @param {Array} userRoles multirole names.
* @returns {boolean} status of access of specified feature.
*/
export async function getDashboard(role?: any, userRoles?: any) {
  var _tabName: any = "";
  var _tabActive = false;
  enum Tab_Types { home, search, myLoad, manage, more };
  const _roleSetting = IONICWrapper.details.keys.configuration.roleConfigurations;

  if (!_roleSetting) {
    return;
  }
  userRole = userRoles;
  if (role) {
    getRole = role;
  }

  for (let i = 0; i <= Object.keys(Tab_Types).length; i++) {
    _tabActive = getActiveTab(Tab_Types[i], getRole, _roleSetting);
    if (_tabActive) {
      _tabName = Tab_Types[i];
      break;
    }
  }

  // REFRESH PART

  if (isWeb) {
    const STOF_KEY = getStateCode();
    
    if (window.localStorage.getItem("REFRESH_URL")) {
      getSearchOrHome();
      _tabName = getTabName(STOF_KEY);
    }
    else if (getGuestRoleCheck()) {
      _tabName = getStofForSearch(STOF_KEY);
    } else {
      _tabName = getStofForHome(STOF_KEY);
    }
  }
  return _tabName;
}

/**
 * To get authentication information and storage API.
 */
export class IONICWrapper {
  private _appVault: any;
  private _appAuth: any;
  private _appKeys: any;
  private _getValue: any = {};
  private _getKeyValuePairs: any = {};
  public static accessToken: any;
  private static instance: IONICWrapper;
  static get details(): IONICWrapper {
    if (!IONICWrapper.instance) {
      IONICWrapper.instance = new IONICWrapper();
    }
    return IONICWrapper.instance;
  }

  /**
   * To get authentication information.
   * @returns {object} consolidated token and user info list.
   */
  get auth() {
    return this._appAuth;
  }

  get keys() {
    return this._appKeys;
  }
  get getValue() {
    return this._getValue;
  }

  getKeyValuePairs(key: any) {
    return this._getKeyValuePairs[key];
  }

  /**
   * To get authentication information.
   * @returns {object} gives storeValue and getValue methods to for storing in Vault.
   */
  get vault() {
    return this._appVault;
  }
  getVault(vault?: any) {
    try {
      this._appVault = vault || {};
    } catch (error) {
      throw new Error(error);
    }
  }
  getAuth(auth?: any) {
    this._appAuth = auth || {};
  }
  getKeys(key?: any) {
    this._appKeys = key || {};
  }

  set setValue(value: any) {
    this._getValue = value || {};
  }

  set setKeyValuePairs(value: any) {
    this._getKeyValuePairs = { ...this._getKeyValuePairs, ...value };
  }

  set setAuth(value: any) {
    this._appAuth = { ...this._appAuth, ...value};
  }

}
function getSearchOrHome(){
  if (compareRefreshURLWithNoacccessUser()) {
    if (getGuestRoleCheck()) {
      return "search";
    } else {
      return "home";
    }
  }
}
function getStateCode() {
  return window.sessionStorage.getItem("stateCode")||'';
}

function getGuestRoleCheck() {
  return userRole[0] === "carrierGuest";
}

function compareRefreshURLWithNoacccessUser() {
  return window.localStorage.getItem("REFRESH_URL") === "noAccess";
}

function getTabName(STOF_KEY: string): any {
  return STOF_KEY ? "stof" : window.localStorage.getItem("REFRESH_URL");
}

function getStofForHome(STOF_KEY: string): any {
  return STOF_KEY ? "stof" : "home";
}

function getStofForSearch(STOF_KEY: string): any {
  return STOF_KEY ? "stof" : "search";
}

export async function setObject(_keyName: string, _obj: any) {
  await Preferences.set({
    key: _keyName,
    value: JSON.stringify(_obj)
  });
}

export async function getObject(_keyName: string) {
  const _ret: any = await Preferences.get({ key: _keyName });
  return _ret.value && JSON.parse(_ret.value);
}

export async function setItem(_key: any, _value: any) {
  await Preferences.set({
    key: _key,
    value: _value
  });
}

export async function getItem(_keyName: string) {
  return await Preferences.get({ key: _keyName });
}

export async function removeItem(_keyName: string) {
  await Preferences.remove({ key: _keyName });
}

export async function keys() {
  return await Preferences.keys();
}

export async function clear() {
  await Preferences.clear();
}
/**
 * method to check if session is active or not. if not, user will be redirected to landing screen.
 * * @param
 * @returns GPSWrapper boolean.
 */
export async function isAuthExpired() {
  const _expiresAt = await getObject(AUTH_SESSION_NAME);
  const _currentTme = Math.floor(new Date().getTime());
  return Math.floor(_currentTme - _expiresAt) / 1000 > 3600;
}

export class GPSWrapper {
  private static instance: GPSWrapper;

  /**
   * singleton design pattern is used to restricts the instantiation of a class to one "single" instance.
   * * @param
   * @returns GPSWrapper object.
   */
  static get details(): GPSWrapper {
    if (!GPSWrapper.instance) {
      GPSWrapper.instance = new GPSWrapper();
    }
    return GPSWrapper.instance;
  }

  /**
   * This is a wrapper method of initiateGPSconfig.
   * initiateGPSconfig method initialize the BackgroundGeolocation plugin Configuration.
   * The Basic Configuration properlies are set.
   * Rest of the custom properlies will be set as per need basis
   * * @param
   * @returns null.
   */
  async initiateGPSconfig() {
    await initiateGPSconfig();
  }

  /**
   * This is a wrapper method of getCurrentPosition.
   * getCurrentPosition method provides the current location latitude and longitude
   * * @param {*} get CurrentGPS callback to process the current location lat, long.
   * @returns null.
   */
  getCurrentPosition(getCurrentGPS: any) {
    getCurrentPosition(getCurrentGPS);
  }

  /**
   *  This is a wrapper method of startGPStracking.
   * startGPStracking method will start the GPS tracking as well as geofence tracking.
   * * @param shipmentDetails to strat the GPS tracking as well as geofence
   *  i.g. activity,shipmentId, carrierScac, userId, sourceSystem
   * @returns null.
   */
  startGPStracking(shipmentDetails: any) {
    startGPStracking(shipmentDetails);
  }

  /**
   *  This This is a wrapper method of sendGeoStartTripLocation
   * * @param shipmentDetails to send the Geo Start Trip Location
   *  i.g. activity,shipmentId, carrierScac, userId, sourceSystem
   * @returns null.
   */
  sendGeoStartTripLocation(shipmentDetails: any) {
    sendGeoStartTripLocation(shipmentDetails);
  }

  /**
   * It will stop the GPS tracking as well as geofence tracking.
   * remove all the GPS tracking data which are stored in local DB.
   * * @param
   * @returns null.
   */
  stopGPS() {
    getGPSinstance().stop().then(async function () {
      setGPStrackingShipmentID(null);
      IONICWrapper.details.vault && (await IONICWrapper.details.vault.storeValue(DB_GPS_ACTIVATED_SHIPMENT,""));
    });
    getGPSinstance().removeGeofences(); //Destroy all [[Geofence]].
    getGPSinstance().destroyLocations(); //Remove all records in SDK's SQLite database.
  }

  /**
   * This is a wrapper method of setGPStrackingShipmentID.
   * setGPStrackingShipmentID method will provide the GPS tracking enabled Shipment ID
   * * @param
   * @returns GPS_Tracking_ShipmentID.
   */
  async getGPStrackingShipmentID() {
    return await getGPStrackingShipmentID();
  }

  getLoadDetailsTrackedShipment() {
    return getLoadDetailsTrackedShipment();
  }

  getState() {
    return getGPSinstance().getState();
  }

  /**
   * This is a wrapper method of setGPStrackingShipmentID.
   * setGPStrackingShipmentID set the GPS tracking enabled Shipment ID
   * * @param GPS_Tracking_ShipmentID
   * @returns null.
   */
  setGPStrackingShipmentID(shipmentID: any) {
    setGPStrackingShipmentID(shipmentID);
  }

  setLoadDetailsTrackedShipment(loadDetailsRefreshedShipment: any) {
    setLoadDetailsTrackedShipment(loadDetailsRefreshedShipment);
  }

  /**
   * This is a wrapper method of getGeofenceSequenceNo.
   * getGeofenceSequenceNo method will GeofenceSequenceNo
   * * @param
   * @returns GeofenceSequenceNo.
   */
  getGeofenceSequenceNo() {
    return getGeofenceSequenceNo();
  }

  /**
   * This is a wrapper method of setGeofenceSequenceNo.
   * setGeofenceSequenceNo set the GeofenceSequenceNo value
   * * @param sequenceNo
   * @returns null.
   */
  setGeofenceSequenceNo(sequenceNo: any) {
    setGeofenceSequenceNo(sequenceNo);
  }
}

/**
 * R2Configuration is a singleton Class
 * used to set and get the R2ConfigurationFlag.
 *
 */
export class R2Configuration {
  private static instance: R2Configuration;
  private static R2ConfigurationFlag = false;

  /**
   * singleton design pattern is used to restricts the instantiation of a class to one "single" instance.
   * * @param
   * @returns R2Configuration object.
   */
  static get details(): R2Configuration {
    if (!R2Configuration.instance) {
      R2Configuration.instance = new R2Configuration();
      R2Configuration.R2ConfigurationFlag = false;
    }
    return R2Configuration.instance;
  }

  /**
   * This method is used to set the R2ConfigurationFlag.
   * * @param {*} flag.
   * @returns null.
   */
  setR2FeatureEnable(flag: boolean) {
    R2Configuration.R2ConfigurationFlag = flag;
  }

  /**
   * This method is used to get the R2ConfigurationFlag.
   * * @param
   * @returns R2ConfigurationFlag.
   */
  getR2FeatureEnable() {
    return R2Configuration.R2ConfigurationFlag;
  }
}

export class GoogleMapsWrapper {
  private static instance: GoogleMapsWrapper;
  static get details(): GoogleMapsWrapper {
    if (!GoogleMapsWrapper.instance) {
      GoogleMapsWrapper.instance = new GoogleMapsWrapper();
    }
    return GoogleMapsWrapper.instance;
  }

  /**
   * This is a wrapper method of getGeoCoderLatLong.
   * Provide the Geo location (latitude, longitude) from city State name.
     * Google API is used to search the location
     *@param {*} {string} postal code 
     * @returns geo coordinates (latitude, longitude)
     */
  async getGeoCoderLatLong(cityState: string) {
    return (await getGeoCoderLatLong(cityState));
  }
}
/**
  * This is a wrapper method for resolving navigation cache related issues.
    *@getNav {string} to get the nvigation screen name. 
    *@setNav {*} to set the nvigation screen name
    * @returns actual selected tab name
*/

export class NAVCACHE {
  private static instance: NAVCACHE;
  private _getValue: any = "";
  static get fetch(): NAVCACHE {
    if (!NAVCACHE.instance) {
      NAVCACHE.instance = new NAVCACHE();
    }
    return NAVCACHE.instance;
  }
  get getNav() {
    return this._getValue;
  }
  set setNav(value: any) {
    this._getValue = value || {};
  }
}

/* To get the double character initial from user full name. */
export const getUserNameInitials = (name: any) => {

  let personaName: string = "";
  let fNameToShow: string = "";
  let lNameToShow: string = "";

  if (name) {
    const nameArr: string[] = name.split(" ");
    let bufferName = "";

    if (nameArr.length > 0) {
      nameArr.forEach((char, index) => {
        if (char && char !== "" && char !== " ") {
          bufferName += `${char} `
        }
      })
      bufferName = bufferName.trim()
      const bufferNameArr = bufferName.split(" ")

      if (bufferNameArr.length > 0) {
        fNameToShow = bufferNameArr[0];
      }

      lNameToShow = getlNameToShow(bufferNameArr, lNameToShow);
    }

    const firstName: string = fNameToShow.slice(0, 1);
    const lastName: string = lNameToShow.slice(0, 1)

    personaName = firstName.toUpperCase() + lastName.toUpperCase();

  } else {
    personaName = "U";
  }
  return personaName;
}

export const isMobile = isPlatform('android') || isPlatform('ios');
export const isWeb = isPlatform("desktop") || isPlatform("mobileweb");

function getlNameToShow(bufferNameArr: string[], lNameToShow: string) {
  if (bufferNameArr.length > 1) {
    for (let index = 1; index < bufferNameArr.length; index++) {
      if (bufferNameArr[index] && bufferNameArr[index] !== "") {
        if (index == 1) {
          lNameToShow = bufferNameArr[index];
        } else {
          lNameToShow += ` ${bufferNameArr[index]}`;
        }
      }
    }
  }
  return lNameToShow;
}

function getOffset(date: any) {
  var sign = (date.getTimezoneOffset() > 0) ? "-" : "+";
  var offset = Math.abs(date.getTimezoneOffset());
  var hours = correct_unit_format(Math.floor(offset / 60));
  var minutes = correct_unit_format(offset % 60);
  return sign + hours + ":" + minutes;
}

export const current_device_date_to_iso_format = () => {
  var currentDate = new Date();
  return new Date(currentDate.getTime() - currentDate.getTimezoneOffset() * 60000).toISOString().replace('Z', '') + getOffset(currentDate)
}

export const correct_unit_format = (value: number) => {
  return value < 10 ? "0" + value : value;
}

/**
 * To get authentication information and storage API.
 */
export class LPEFeedbackWrapper {

  public static _lpeFeedbackSource: any;
  public static source: LPEFeedback.ILPESource;

  public static accessToken: any;
  private static instance: LPEFeedbackWrapper;
  static get details(): LPEFeedbackWrapper {
    if (!LPEFeedbackWrapper.instance) {
      LPEFeedbackWrapper.instance = new LPEFeedbackWrapper();
    }
    return LPEFeedbackWrapper.instance;
  }

  static log(
    name: string,
    parameters: object,
    sessionFields: string[] = []
  ) {

    if (this._lpeFeedbackSource) {
      //construct the object here
      this._lpeFeedbackSource(name, this.constructPayload(name, parameters, sessionFields));

    }

  }

  static setSource(source: LPEFeedback.ILPESource) {
    this.source = source;
    this._lpeFeedbackSource = source.logFeedbackEvents || {};
  }

  static constructPayload(
    name: string,
    parameters: object,
    sessionFields: string[]
  ): LPEFeedback.ILPESourceProperties {

    return this.source.getFeedbackPayloadData(name, parameters, sessionFields);

  }

}

export const isCarrierGuest: Function = (): boolean =>
  IONICWrapper.details &&
  IONICWrapper.details.auth &&
  IONICWrapper.details.auth.user &&
  IONICWrapper.details.auth.user.roles &&
  IONICWrapper.details.auth.user.roles.length === 1 &&
  IONICWrapper.details.auth.user.roles.includes(Roles.carrierGuest);

export { GeographicalService };

/**
  * This is a validation method for document viewer according to sourceTMS.
    * @param {EsourceTMSList} sourceTMS to get the sourceTMS for a load. 
    * @param {EdivisionList} division to get the division for a load. 
    * @param {ESOURCE_TYPE_CHECK} typeCheck to get the type for a load validation. ie. view,upload. 
    *@returns {boolean} if the configuration and validation allows to view documents.
*/
export const SourceTMSValidation = (
  sourceTMS: EsourceTMSList,
  division: EdivisionList,
  typeCheck: ESOURCE_TYPE_CHECK
): boolean => {
  let isValid = false;
  const fallback_data = MYLOAD_DOCUMENT_UPLOAD?.GENERAL_DOCUMENT_CONFIG?.[sourceTMS]?.[division]?.[typeCheck];
  const typecheck_data = IONICWrapper.details.getKeyValuePairs(CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key)?.GENERAL_DOCUMENT_CONFIG?.[sourceTMS]?.[division]?.[typeCheck]
    ?? fallback_data ?? [];
  let role = IONICWrapper.details?.auth?.user?.roles;
  isValid = typecheck_data.length > 0 && typecheck_data.some(
    (element: any) => {
      return role?.includes(element);
    }
  )
  return isValid;
};
export const getConfigWithSourceTMSValidation = (
  sourceTMS: EsourceTMSList,
  division: EdivisionList,
  typeCheck: ESOURCE_TYPE_CHECK
): any => {
  let roles = IONICWrapper.details?.auth?.user?.roles || [];
  if (typeCheck === ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_TYPE) {
    const documentType = IONICWrapper.details.getKeyValuePairs(CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key)?.DOCUMENT_TYPE || MYLOAD_DOCUMENT_UPLOAD?.DOCUMENT_TYPE;
    const _data = IONICWrapper.details.getKeyValuePairs(CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key)?.GENERAL_DOCUMENT_CONFIG || MYLOAD_DOCUMENT_UPLOAD?.GENERAL_DOCUMENT_CONFIG;
    const typecheck_data = (_data?.[sourceTMS]?.[division]?.[ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_TYPE]) || [];
    const unique_typecheck_data = !isEmptyObject(typecheck_data) ? Array.from(new Set(Object.entries(typecheck_data)?.map(([key, value]) => {
      if (roles.includes(key)) return value;
      return [];
    })?.flat())) : [];
    const populatedData = unique_typecheck_data && unique_typecheck_data?.map((item: any) => documentType[item]);
    return populatedData || [];
  } else {
    const fallback_data = MYLOAD_DOCUMENT_UPLOAD?.GENERAL_DOCUMENT_CONFIG?.[sourceTMS]?.[division]?.[typeCheck];
    const typecheck_data = IONICWrapper.details.getKeyValuePairs(CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key)?.GENERAL_DOCUMENT_CONFIG?.[sourceTMS]?.[division]?.[typeCheck]
      ?? fallback_data ?? [];
    return typecheck_data;
  }
};
export const getSNIConfigTrailerdropdownDataValue = (type: any ) =>{ 
    return IONICWrapper.details && IONICWrapper.details.keys &&
     IONICWrapper.details.keys.configuration && 
     IONICWrapper.details.keys.configuration.trailerDropdownData &&
     IONICWrapper.details.keys.configuration.trailerDropdownData[type]
}
export const ISGUEST = (props: any) =>
props && props.userDetails && props.userDetails.memberDetailsResponse &&
props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.userApplicationDetails &&
  props.userDetails.memberDetailsResponse.member.userApplicationDetails.length &&
  props.userDetails.memberDetailsResponse.member.userApplicationDetails.length === 1 &&
  props.userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles &&
  props.userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles.length &&
  props.userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles.length === 1 &&
  props.userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles.find(
    (item: any) => item.roleName === Roles.carrierGuest
  ) || null;
export const isAdminRoleAvailble: Function = (): boolean =>
  IONICWrapper.details &&
  IONICWrapper.details.auth &&
  IONICWrapper.details.auth.user &&
  IONICWrapper.details.auth.user.roles &&
  IONICWrapper.details.auth.user.roles.length > 0 &&
  IONICWrapper.details.auth.user.roles.includes(Roles.carrierAdmin);

export const getDriverFirstLastName = (user: any) => {
  let driverFirstNameLastName = IONICWrapper.details.keys?.configuration?.driverNameUnknown;
  if (user?.firstName || user.lastName) {
    driverFirstNameLastName = `${user.firstName && user.firstName + ' '} ${user.lastName}`;
  }
    return driverFirstNameLastName;
  }

export const getDeviceInfo = async () => {
  return await Device.getInfo();
};

export const navigate = async () => {
  const redirectionSchneiderCarrierURL = IONICWrapper.details.keys 
      && IONICWrapper.details.keys.configuration.redirection_schneider_carrier_url 
        || REDIRECTION_SCHNEIDER_CARRIER_URL;
  await Browser.open({ url: redirectionSchneiderCarrierURL });
};

export const validatePhoneNumberFormat = (mobilenumber: string) => {
  if (mobilenumber) {
    mobilenumber = mobilenumber.replace(/[^+0-9+]*/g, '');
  }
  return mobilenumber;
};

export const deepLinkObjCreation = (str: string | null) => {
  let finalObj = {};
  if (str) {
    const t1 = str.replace(/"/g, "").replace(/ /g, "").replace(/\n/g, "").replace(/\t/g, "").split("{");
    const t2 = t1[t1.length - 1].split("}");
    const t3 = t2[0].split(",");
    t3.forEach((item: string) => {
      if (item) {
        let [key, value] = item.split(":");
        finalObj = {
          ...finalObj,
          [key]: value
        }
      }
    })
  }
  return finalObj;
};

export const getMembersRequestPayload = (modelList : any ,userDetails: IUserDetails) => {
    modelList.carrierId = userDetails?.memberDetailsResponse?.member?.carrierId;
    modelList.roleName = "carrierDriver";
    modelList.page = IONICWrapper?.details?.keys?.configuration?.getMembersConfig?.page || GET_MEMBERS_CONFIG.page;
    modelList.size = IONICWrapper?.details?.keys?.configuration?.getMembersConfig?.size || GET_MEMBERS_CONFIG.size;
    modelList.sort = IONICWrapper?.details?.keys?.configuration?.getMembersConfig?.sort || GET_MEMBERS_CONFIG.sort;
    return modelList
}

export const payloadCreationForReSendInviteNotification = (data: any) => {
  let payload : FormData = new FormData();
  const { mobileNumber: phoneNumber ,companyName:carrierName ,...rest } = data; 
  const updatedObject = { phoneNumber,carrierName, ...rest };
  payload.append("upn", updatedObject?.upn || "");
  payload.append("email", updatedObject?.email || "");
  payload.append("phoneNumber", updatedObject?.phoneNumber || "");
  payload.append("carrierName", updatedObject?.carrierName || "");
  return payload;
};

export const getReduxData=(key: string) =>{
  const storeData = store.getState();
  return storeData && storeData.App && storeData.App.tab_name;
}

export const createMarkup = (content : any) => {
  const clean = DOMPurify.sanitize(content);
  return {__html: clean};
}